import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";

export default forwardRef(function ProfessionalInfoStep(
  { setCanProceed },
  ref
) {
  const [profissao, setProfissao] = useState("");
  const [formacao, setFormacao] = useState("");
  const [dependents, setDependents] = useState("");
  const [cnpj, setCnpj] = useState("");

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  // Valida campos
  const validateFields = () => {
    const errs = {};
    if (!profissao) errs.profissao = "Profissão obrigatória.";
    if (!formacao) errs.formacao = "Formação obrigatória.";
    if (!dependents) errs.dependents = "Escolha uma opção.";
    if (!cnpj) errs.cnpj = "Escolha uma opção.";
    return errs;
  };

  // expose para CardWithLogo
  useImperativeHandle(ref, () => ({
    getData() {
      return {
        profession: profissao,
        education: formacao,
        dependents,
        cnpj,
      };
    },
    validateStep() {
      const errs = validateFields();
      setErrors(errs);
      return Object.keys(errs).length === 0;
    },
  }));

  // habilita botão quando tudo preenchido
  useEffect(() => {
    const allFilled =
      profissao && formacao && dependents && cnpj;
    setCanProceed(allFilled);
  }, [profissao, formacao, dependents, cnpj, setCanProceed]);

  // onBlur marca touched e seta erros
  const handleBlur = (field) => {
    setTouched((t) => ({ ...t, [field]: true }));
    setErrors(validateFields());
  };
  // onChange limpa erro assim que válido
  const handleChange = (field, value) => {
    switch (field) {
      case "profissao":
        setProfissao(value);
        break;
      case "formacao":
        setFormacao(value);
        break;
      case "dependents":
        setDependents(value);
        break;
      case "cnpj":
        setCnpj(value);
        break;
    }
    if (touched[field]) {
      const errs = validateFields();
      if (!errs[field]) {
        setErrors((e) => {
          const { [field]: _, ...rest } = e;
          return rest;
        });
      }
    }
  };

  const inputClass =
    "w-full h-12 px-4 border border-[#E5E7EB] bg-[#F9FAFB] rounded-md placeholder-gray-400 text-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-[#2A4DD0]";

  return (
    <div className="flex flex-col gap-6">
      {/* Profissão */}
      <div>
        <label className="block font-semibold text-gray-900 mb-1">
          Profissão*
        </label>
        <input
          className={inputClass}
          value={profissao}
          onBlur={() => handleBlur("profissao")}
          onChange={(e) =>
            handleChange("profissao", e.target.value)
          }
          placeholder="Qual é a sua profissão?"
        />
        {touched.profissao && errors.profissao && (
          <p className="text-red-500 text-sm mt-1">
            {errors.profissao}
          </p>
        )}
      </div>

      {/* Formação */}
      <div>
        <label className="block font-semibold text-gray-900 mb-1">
          Formação*
        </label>
        <input
          className={inputClass}
          value={formacao}
          onBlur={() => handleBlur("formacao")}
          onChange={(e) =>
            handleChange("formacao", e.target.value)
          }
          placeholder="Qual é a sua formação?"
        />
        {touched.formacao && errors.formacao && (
          <p className="text-red-500 text-sm mt-1">
            {errors.formacao}
          </p>
        )}
      </div>

      {/* Dependentes */}
      <div>
        <label className="block font-semibold text-gray-900 mb-1">
          Você vai querer incluir dependentes?*
        </label>
        <div className="flex gap-4">
          {["sim", "não"].map((opt) => (
            <label
              key={opt}
              className="flex items-center space-x-2"
            >
              <input
                type="radio"
                name="dependents"
                value={opt}
                checked={dependents === opt}
                onBlur={() => handleBlur("dependents")}
                onChange={() =>
                  handleChange("dependents", opt)
                }
              />
              <span className="text-gray-800 capitalize">
                {opt}
              </span>
            </label>
          ))}
        </div>
        {touched.dependents && errors.dependents && (
          <p className="text-red-500 text-sm mt-1">
            {errors.dependents}
          </p>
        )}
      </div>

      {/* CNPJ */}
      <div>
        <label className="block font-semibold text-gray-900 mb-1">
          Possui CNPJ?*
        </label>
        <div className="flex gap-4">
          {["sim", "não"].map((opt) => (
            <label
              key={opt}
              className="flex items-center space-x-2"
            >
              <input
                type="radio"
                name="cnpj"
                value={opt}
                checked={cnpj === opt}
                onBlur={() => handleBlur("cnpj")}
                onChange={() =>
                  handleChange("cnpj", opt)
                }
              />
              <span className="text-gray-800 capitalize">
                {opt}
              </span>
            </label>
          ))}
        </div>
        {touched.cnpj && errors.cnpj && (
          <p className="text-red-500 text-sm mt-1">
            {errors.cnpj}
          </p>
        )}
      </div>
    </div>
  );
});
